// Internal modules
// @ts-expect-error untyped-import
import { createCardTypesChangeHandlerForField } from '../utils';

/**
 * Used to revalidate the CVV after the card type changes
 * E.G. user enters Visa and a CVV of length of 3 (valid for Visa)
 * Then the user changes their card to an Amex card. The CVV of length 3
 * should now be marked as invalid since Amex CVVs are 4 numbers long
 */
const cardTypeChangeHandler = createCardTypesChangeHandlerForField('cardCvv');

export { cardTypeChangeHandler };
